import { PreviewGallery } from "../../components/3d/preview.gallery"
import { ButtonContainer } from "../../components/organisms/ButtonContainer"

export const PreviewSpace = () => {
    return (
        <div>
            <div className="hexa">
                <PreviewGallery />
                <ButtonContainer showFeedback />
            </div>
        </div>
    )
}
